import React from 'react';
import { Link } from 'react-router-dom';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  crumb: string;
  image: string;
}
export function PageHeader({
  title,
  subtitle,
  crumb,
  image
}: PageHeaderProps) {
  return <section className="relative bg-ink pb-12 pt-6 md:pb-16 md:pt-8" data-id="element-208" data-mp="1ofv1a3ejvb40">
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-flame" aria-hidden="true" data-id="element-209" data-mp="1jh1rom2dw494" />
      <div className="relative mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-210" data-mp="2h4k7ggugq6mm">
        <div className="relative overflow-hidden rounded-[28px] bg-coal md:rounded-[36px]" data-id="element-211" data-mp="2h1o76lv575v0">
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-212" data-mp="2c339ou79z0a9" />
          <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-213" data-mp="277xmzt61thl4" />
          <div className="relative px-6 py-16 text-center md:px-14 md:py-28 md:text-left" data-id="element-214" data-mp="2268byditt3x1">
            <nav aria-label="Breadcrumb" className="text-xs font-semibold uppercase tracking-[0.14em] text-chalk/60" data-id="element-215" data-mp="vrh39nngoesg">
              <Link to="/" className="transition-colors duration-150 hover:text-chalk" data-id="element-216" data-mp="qq9y7wcpdtph">
                Home
              </Link>
              <span className="mx-2 text-flame" data-id="element-217" data-mp="r5i72rwk3rx2">/</span>
              <span className="text-chalk/90" data-id="element-218" data-mp="r504ldjawhgp">{crumb}</span>
            </nav>
            <h1 className="mx-auto mt-5 max-w-4xl font-display text-5xl font-bold uppercase leading-[0.9] text-chalk sm:text-6xl md:mx-0 md:text-8xl" data-id="element-219" data-mp="c77punlkvx3k">
              {title}
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-chalk/75 md:mx-0 md:text-xl" data-id="element-220" data-mp="3fnwyi3mghgi">{subtitle}</p>
          </div>
        </div>
      </div>
    </section>;
}